import fetch from '@/utils/fetch';

//获取ocr学校管理
export function queryOcrSchool(listQuery) {
    let params = new URLSearchParams();
    params.append('pageNo', listQuery.pageNo);
    params.append('pageSize', listQuery.pageSize);
    params.append('searchName', listQuery.searchName);
    params.append('areaCode', listQuery.areaCode);
    return fetch({
        url: 'structure/ocr/queryOcrSchool',
        method: 'get',
        params
    });
  }
  //充值提醒
export function rechargeRemind(schoolId) {
    let params = new URLSearchParams();
    params.append('schoolId', schoolId);
    return fetch({
        url: 'structure/ocr/rechargeRemind',
        method: 'GET',
        params
    });
}
//更改学校ocr单价
export function updateOcrSchool(listQuery) {
    let params = new URLSearchParams();
    params.append('id', listQuery.id);
    params.append('peopleCount', listQuery.peopleCount);
    params.append('price', listQuery.price);
    return fetch({
        url: 'structure/ocr/updateOcrSchool',
        method: 'post',
        data:params
    });
  }
  //客服充值
export function serviceRecharge(listQuery) {
    let params = new URLSearchParams();
    params.append('areaCode', listQuery.areaCode);
    params.append('count', listQuery.count);
    params.append('money', listQuery.money);
    params.append('price', listQuery.price);
    params.append('realMoney', listQuery.realMoney);
    params.append('remark', listQuery.remark);
    params.append('schoolId', listQuery.schoolId);
    params.append('schoolName', listQuery.schoolName);
    params.append('state', listQuery.state);
    params.append('type', listQuery.type);
    return fetch({
        url: 'structure/ocr/serviceRecharge',
        method: 'post',
        data:params
    });
  }
  //初始化安装行程报备的学校（非鉴权）
export function initAllOcrSchool() {
    let params = new URLSearchParams();
    return fetch({
        url: 'common/ocr/initAllOcrSchool',
        method: 'get'
    });
  }
  export function refreshPeopleCount() {
    let params = new URLSearchParams();
    return fetch({
        url: 'structure/ocr/refreshPeopleCount',
        method: 'get'
    });
  }
    //根据id删除充值记录
export function deleteOcrPayRecordById(id) {
    let params = new URLSearchParams();
    params.append('id', id);
    return fetch({
        url: 'structure/ocr/deleteOcrPayRecordById',
        method: 'GET',
        params
    });
}
//查询学校充值记录
export function querySchoolOcrPayRecord(listQuery) {
    let params = new URLSearchParams();
    params.append('pageNo', listQuery.pageNo);
    params.append('pageSize', listQuery.pageSize);
    params.append('schoolId', listQuery.schoolId);
    return fetch({
        url: 'structure/ocr/querySchoolOcrPayRecord',
        method: 'get',
        params
    });
  }
//查询充值记录
export function queryOcrPayRecord(listQuery) {
    let params = new URLSearchParams();
    params.append('pageNo', listQuery.pageNo);
    params.append('pageSize', listQuery.pageSize);
    params.append('searchName', listQuery.searchName);
    params.append('type', listQuery.type);
    return fetch({
        url: 'structure/ocr/queryOcrPayRecord',
        method: 'get',
        params
    });
  }
    //审核线下充值
export function auditOfflineRecharge(listQuery) {
    let params = new URLSearchParams();
    params.append('auditContent', listQuery.auditContent);
    params.append('count', listQuery.count);
    params.append('money', listQuery.money);
    params.append('id', listQuery.id);
    params.append('price', listQuery.price);
    params.append('realMoney', listQuery.realMoney);
    params.append('state', listQuery.state);
    return fetch({
        url: 'structure/ocr/auditOfflineRecharge',
        method: 'post',
        data:params
    });
  }


// WEBPACK FOOTER //
// ./src/api/Identificationmanagement.js